// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"24c75b7d","595":"924ecca6","750":"2cbc4998","842":"f9be520b","928":"2b935367"}[chunkId] + ".chunk.css";
};